@use '../../../scss/global/spacing';
@use '../../../scss/global/color';
@use '../../../scss/global/border';

@use './button.mixins' as mixins;
@use './button.vars' as *;

:host {
  @include mixins.button-disabled;
  @include mixins.button-hovered-not-disabled;
  @include mixins.button-focused-not-active;
  @include mixins.button-active-not-disabled;

  display: inline-flex;

  .fds-button__button {
    @include mixins.button-box-shadow(var(--default-border-color));
    @include mixins.button-font;
    @include mixins.button-spacing;

    position: relative;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    user-select: none;
    outline: none;
    border: none;
    cursor: pointer;
    border-radius: var(--fds-button-border-radius);
    background-color: var(--default-background-color);
    color: var(--default-text-color);

    span {
      &.button-icon {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      &.button-icon-left {
        margin-right: spacing.$spacer-3;
      }

      &.button-icon-right {
        margin-left: spacing.$spacer-3;
      }
    }

    &--icon-button {
      padding: spacing.$spacer-3 spacing.$spacer-4;
    }

    &--cta {
      --fds-button-border-radius: #{border.$radius-4};

      padding: spacing.$spacer-2 spacing.$spacer-6;
    }

    &--loading {
      cursor: wait;

      &.fds-button__button--no-text {
        padding: spacing.$spacer-2;

        span {
          &.button-icon,
          &.button-icon-left,
          &.button-icon-right {
            visibility: hidden;
          }
        }

        slot {
          visibility: hidden;
        }

        fds-loader {
          position: absolute;
          inset: auto;
          color: var(--loading-icon-color);
        }
      }

      &:not(.fds-button__button--no-text) {
        span {
          &.button-icon,
          &.button-icon-left,
          &.button-icon-right {
            display: none;
          }
        }
      }

      &.fds-button__button--left:not(.fds-button__button--no-text) {
        fds-loader {
          margin-right: spacing.$spacer-3;
        }
      }

      &.fds-button__button--right:not(.fds-button__button--no-text) {
        fds-loader {
          margin-left: spacing.$spacer-3;
        }
      }
    }
  }
}

:host(.fds-button--full-width) {
  display: flex;

  .fds-button__button--full-width {
    flex: 1;
  }
}
